module.exports = __webpack_public_path__ + "img/LV40003775465.21ac2761.png";